export const ADVANCE_INITIAL_SEARCH_KEY = "advance_initial_search";
export const ADVANCE_INITIAL_PAYMENT_ID_KEY = "advance_initial_payment_id";

interface AdvancePaymentNavigationTarget {
    titleEan13?: string | null;
    paymentId?: number | null;
}

export function storeAdvancePaymentNavigationTarget({ titleEan13, paymentId }: AdvancePaymentNavigationTarget): void {
    if (titleEan13?.trim()) {
        sessionStorage.setItem(ADVANCE_INITIAL_SEARCH_KEY, titleEan13.trim());
    }
    if (paymentId != null) {
        sessionStorage.setItem(ADVANCE_INITIAL_PAYMENT_ID_KEY, String(paymentId));
    }
}

export function consumeAdvancePaymentNavigationTarget(): number | null {
    const paymentIdStr = sessionStorage.getItem(ADVANCE_INITIAL_PAYMENT_ID_KEY);
    if (!paymentIdStr) return null;
    sessionStorage.removeItem(ADVANCE_INITIAL_PAYMENT_ID_KEY);
    const paymentId = Number(paymentIdStr);
    return Number.isFinite(paymentId) ? paymentId : null;
}
